// export const mainUrl = 'http://localhost:5555/';
// export const mainUrl = 'https://nobody-app.herokuapp.com/';
export const mainUrl = 'https://nobody-server.vercel.app/';
export const userUrlUrl = `${mainUrl}api/user/url`;
export const projectsUrl = `${mainUrl}api/projects/`;
export const getProjectUrl = (id) => `${mainUrl}api/project?id=${id}`;
